import {
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { noticeToCreditorsFlow } from "../index";
import { Formik, FormikHelpers } from "formik";
import * as Yup from "yup";
import { ScreenFlowFormButtons } from "../shared/ScreenFlowFormButtons";
import { FlowScreenWrapper } from "../shared/FlowScreenWrapper";

export enum Outcomes {
  yes = "yes",
  no = "no",
  dont_know = "dont_know",
}

interface Values {
  ownProperty: string;
}

interface Props {
  screenData?: Record<string, string | number | boolean>[];
}

export const EstateProperty = ({ screenData }: Props): JSX.Element => {
  const navigate = useNavigate();
  const { screenName } = useParams();
  const currentScreen = noticeToCreditorsFlow.getCurrentFlowScreen(screenName);

  console.log(`${currentScreen} screenData: ${JSON.stringify(screenData)}`);

  const ownProperty =
    (screenData?.length && (screenData[0]?.ownProperty as string)) || "";

  // https://formik.org/docs/api/formik
  const formikInit = {
    values: {
      ownProperty,
    },
    schema: Yup.object().shape({
      ownProperty: Yup.string().required("Please select role"),
    }),
  };

  const handleSubmit = async (
    values: Values,
    { setSubmitting, setStatus }: FormikHelpers<Values>
  ) => {
    setStatus("");
    try {
      if (!currentScreen) throw Error("couldn't determine currentScreen");

      // TODO: save to database
      // console.log(`values: ${JSON.stringify(values)}`);

      // TODO: fix
      const saved = await noticeToCreditorsFlow.saveData(currentScreen, 0, {
        ownProperty: values.ownProperty,
      });
      console.log(`saved: ${saved}`);

      noticeToCreditorsFlow.navigateToNext(
        currentScreen,
        values.ownProperty,
        navigate
      );
    } catch (error) {
      setStatus("Sorry, error: " + ((error as Error)?.message || ""));
      // console.error(error);
      setSubmitting(false);
    }
  };

  return currentScreen ? (
    <FlowScreenWrapper
      title="Did [Jacob] own property anywhere else?"
      subTitle="This is typically a second residence or rental property."
    >
      <Formik
        initialValues={formikInit.values}
        validationSchema={formikInit.schema}
        onSubmit={handleSubmit}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
          // touched,
          values,
          status,
        }) => (
          <form onSubmit={handleSubmit}>
            <Grid
              container
              spacing={2}
              sx={{
                my: 1,
              }}
            >
              <Grid item xs={12}>
                <RadioGroup
                  aria-label="ownProperty"
                  name="ownProperty"
                  value={values.ownProperty}
                  onBlur={handleBlur}
                  onChange={handleChange}
                // error={Boolean(touched.role && errors.role)}
                >
                  <FormControlLabel
                    value={Outcomes.yes}
                    control={<Radio />}
                    label="Yes"
                  />
                  <FormControlLabel
                    value={Outcomes.no}
                    control={<Radio />}
                    label="No"
                  />
                  <FormControlLabel
                    value={Outcomes.dont_know}
                    control={<Radio />}
                    label="I don't know"
                  />
                </RadioGroup>
                <Typography variant="body1" color="error">
                  {errors.ownProperty}
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <ScreenFlowFormButtons
                  isSubmitting={isSubmitting}
                  status={status}
                  onBack={() => navigate(-1)}
                />
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
    </FlowScreenWrapper>
  ) : (
    <></>
  );
};
